import React from 'react';

const DeleteProductsModal = ({ deleteProduct, reload, setIsReload }) => {
    const { _id } = deleteProduct;

    const handleItemDelete = id => {
        console.log(id)
        const url = `https://young-everglades-39818.herokuapp.com/products/${id}`;
        console.log(url)
        fetch(url, {
            method: 'DELETE'
        })
            .then(res => res.json())
            .then(data => {
                setIsReload(!reload)
            })

    }


    return (
        <div>
            <input type="checkbox" id="my-modal" class="modal-toggle" />
            <div class="modal modal-bottom sm:modal-middle">
                <div class="modal-box">
                    <h3 class="font-bold text-lg">Are you sure about deleting this product?</h3>
                    <p class="py-4">Deletion is permanent, you can't go reverse once the item is deleted. Select confirm to delete, or cancel the operation!!!</p>
                    <div class="modal-action">
                        <label for="my-modal" class="btn" onClick={() => handleItemDelete(_id)}>Confirm</label>
                        <label for="my-modal" class="btn">Cancel</label>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default DeleteProductsModal;